import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import artistsComponent from './artists.component';

const artistsModule = angular
  .module('artists', [uiRouter])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('index.artists', {
      url: '/artists?discipline',
      reloadOnSearch: false,
      resolve: {
        disciplines: (ApiService) => ApiService.taxonomy('disciplines'),
        artists: (ApiService) =>
          ApiService.entitySearch({
            q: 'schema:artist',
            children: ['assets[*]:group(2):sample(3)'],
            sort: 'sort.fields.lastName<string>',
          }).then((result) => ({ docs: result.rows })),
      },
      views: {
        content: {
          component: 'artists',
        },
      },
    });
  })

  .component('artists', artistsComponent);

export default artistsModule;
